export default __webpack_public_path__ + "static/media/Minor Elixir of Resurgence.f079228a.jpg";